import * as React from "react";
import type { SARecommendation, SAAgent } from "@/data/sellerAnalysisTypes";
import { Reveal, Overline } from "@/components/presentation/primitives";

interface Props {
  recommendation: SARecommendation;
  agent: SAAgent;
}

export const SA_Recommendation: React.FC<Props> = ({ recommendation, agent }) => {
  if (!recommendation?.body) return null;

  return (
    <section
      className="w-full bg-ivory py-20 md:py-28"
      data-testid="sa-recommendation"
      aria-label="My initial recommendation"
    >
      <div className="mx-auto w-full max-w-3xl px-6 md:px-10">
        <Reveal>
          <Overline>My initial recommendation</Overline>
          <p className="mt-8 font-serif text-2xl leading-[1.45] text-charcoal md:text-[1.7rem]">
            {recommendation.body}
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex items-center gap-4 border-t border-charcoal/10 pt-8">
            {agent.photoUrl && (
              <img
                src={agent.photoUrl}
                alt={agent.name}
                loading="lazy"
                decoding="async"
                className="h-14 w-14 shrink-0 rounded-full object-cover object-top md:h-16 md:w-16"
              />
            )}
            <div>
              <p className="signature text-2xl text-charcoal md:text-3xl">{agent.name}</p>
              {(agent.title || agent.brokerage) && (
                <p className="mt-1 text-xs uppercase tracking-[0.16em] text-charcoal-muted">
                  {[agent.title, agent.brokerage].filter(Boolean).join(" · ")}
                </p>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
